var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"out",on:{"mousedown":function($event){$event.preventDefault();return _vm.mousedown.apply(null, arguments)},"touchend":function($event){$event.preventDefault();return _vm.mousedown.apply(null, arguments)},"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"handle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }